import { render, staticRenderFns } from "./ModalConfirmShareInformation.vue?vue&type=template&id=5e476d1e&scoped=true"
import script from "./ModalConfirmShareInformation.vue?vue&type=script&lang=js"
export * from "./ModalConfirmShareInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e476d1e",
  null
  
)

export default component.exports